<template>
  <v-app-bar app>
    <v-toolbar-title class="mx-8">Flow Credit Assessment</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn :to="'/company/list'" text>Company List</v-btn>
    <v-btn :to="'/company/new'" text>New Company</v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'CompanyHeader',
}
</script>
